import i18n from 'utils/i18n'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  RADIO_LIST,
  SCORE,
  INTERVAL,
  SWITCHER,
  RHEOSTAT,
  offersFiltersTitle,
  offersFiltersName,
  offersFiltersKey,
  SEARCH_USERS,
  MULTISELECT_SWITCHER,
  RRP_INTERVAL,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'

export const getAdministrationTradeOffersFiltersCollection = () => [
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.eshopCountryFilter),
    filterName: ADMIN_FILTERS_NAME.eshopCountryFilter,
    apiFilterName: ADMIN_FILTERS_KEY.eshopCountryFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.eshopFilter),
    filterName: ADMIN_FILTERS_NAME.merchantFilter,
    apiFilterName: ADMIN_FILTERS_KEY.merchantFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineCountryFilter),
    filterName: ADMIN_FILTERS_NAME.productCountryFilter,
    apiFilterName: ADMIN_FILTERS_KEY.productCountryFilter,
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.producerFilter),
    filterName: ADMIN_FILTERS_NAME.tradeNameFilter,
    apiFilterName: ADMIN_FILTERS_KEY.tradeNameFilter,
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.productBrandFilter),
    filterName: ADMIN_FILTERS_NAME.productBrandFilter,
    apiFilterName: ADMIN_FILTERS_KEY.productBrandFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.additionalNameFilter),
    filterName: ADMIN_FILTERS_NAME.additionalNameFilter,
    apiFilterName: ADMIN_FILTERS_KEY.additionalNameFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.withAdditionalNameFilter),
    filterName: ADMIN_FILTERS_NAME.withAdditionalNameFilter,
    apiFilterName: ADMIN_FILTERS_KEY.withAdditionalNameFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineRegionEUFilter),
    filterName: ADMIN_FILTERS_NAME.wineRegionEUFilter,
    apiFilterName: ADMIN_FILTERS_KEY.wineRegionEUFilter,
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.nationalGITypeFilter),
    filterName: ADMIN_FILTERS_NAME.nationalGITypeFilter,
    apiFilterName: ADMIN_FILTERS_KEY.nationalGITypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.geoIndicationFilter),
    filterName: ADMIN_FILTERS_NAME.geoIndicationFilter,
    apiFilterName: ADMIN_FILTERS_KEY.geoIndicationFilter,
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.specialClassificationFilter),
    filterName: ADMIN_FILTERS_NAME.specialClassificationFilter,
    apiFilterName: ADMIN_FILTERS_KEY.specialClassificationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineTypeFilter),
    filterName: ADMIN_FILTERS_NAME.wineTypeFilter,
    apiFilterName: ADMIN_FILTERS_KEY.wineTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineColourFilter),
    filterName: ADMIN_FILTERS_NAME.wineColourFilter,
    apiFilterName: ADMIN_FILTERS_KEY.wineColourFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.sweetnessTypeFilter),
    filterName: ADMIN_FILTERS_NAME.sweetnessTypeFilter,
    apiFilterName: ADMIN_FILTERS_KEY.sweetnessTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.vintageFilter),
    filterName: ADMIN_FILTERS_NAME.vintageFilter,
    apiFilterName: ADMIN_FILTERS_KEY.vintageFilter,
  },
  {
    type: filterTypes[MULTISELECT_SWITCHER],
    title: i18n.t(offersFiltersTitle.grapesFilter),
    filterName: offersFiltersName.grapesFilter,
    apiFilterName: offersFiltersKey().grapesFilter,
    switchType: filterTypes[SWITCHER],
    switchFilterName: offersFiltersName.monocepageFilter,
    switchTitle: i18n.t(offersFiltersTitle.monocepageFilter),
    switchApiFilterName: offersFiltersKey().monocepageFilter,
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.bottleSizeFilter),
    filterName: ADMIN_FILTERS_NAME.bottleSizeFilter,
    apiFilterName: ADMIN_FILTERS_KEY.bottleSizeFilter,
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.packageTypeFilter),
    filterName: ADMIN_FILTERS_NAME.packageTypeFilter,
    apiFilterName: ADMIN_FILTERS_KEY.packageTypeFilter,
  },
  {
    type: filterTypes[INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.alcoholLevelFilter),
    filterName: offersFiltersName.alcoholLevelFilter,
    apiFilterName: ADMIN_FILTERS_KEY.alcoholLevelFilter,
    defaultIntervalKey: 'alcoholLevels',
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.certificatesFilter),
    filterName: offersFiltersName.certificatesFilter,
    apiFilterName: offersFiltersKey().certificatesFilter,
  },
  {
    type: filterTypes[SCORE],
    title: i18n.t(offersFiltersTitle.wwlRatingFilter),
    filterName: offersFiltersName.wwlRatingFilter,
    apiFilterName: offersFiltersKey().wwlRatingFilter,
  },
  {
    type: filterTypes[RRP_INTERVAL],
    title: i18n.t(offersFiltersTitle.rrpFilter),
    filterName: offersFiltersName.rrpFilter,
    apiFilterName: 'product.priceAtWinery',
    defaultIntervalKey: 'priceInterval',
  },
  {
    type: filterTypes[RHEOSTAT],
    title: i18n.t(offersFiltersTitle.priceCoefFilter),
    filterName: offersFiltersName.priceCoefFilter,
    apiFilterName: offersFiltersKey().priceCoefFilter,
  },

  {
    type: filterTypes[RRP_INTERVAL],
    title: i18n.t(offersFiltersTitle.priceFilter),
    filterName: offersFiltersName.pricePerBottleFilter,
    apiFilterName: 'pricePerBottle',
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineLotFilter),
    filterName: ADMIN_FILTERS_NAME.wineLotFilter,
    apiFilterName: ADMIN_FILTERS_KEY.wineLotFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.vatBehaviorFilter),
    filterName: ADMIN_FILTERS_NAME.vatBehaviorFilter,
    apiFilterName: ADMIN_FILTERS_KEY.vatBehaviorFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.purchaseConditionFilter),
    filterName: ADMIN_FILTERS_NAME.purchaseConditionFilter,
    apiFilterName: ADMIN_FILTERS_KEY.purchaseConditionFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.deliveryCostFilter),
    filterName: ADMIN_FILTERS_NAME.deliveryCostFilter,
    apiFilterName: ADMIN_FILTERS_KEY.deliveryCostFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.uniqueProductURLFilter),
    filterName: ADMIN_FILTERS_NAME.uniqueProductURLFilter,
    apiFilterName: ADMIN_FILTERS_KEY.uniqueProductURLFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.lotCreatedAtFilter),
    filterName: ADMIN_FILTERS_NAME.lotCreatedAtFilter,
    apiFilterName: ADMIN_FILTERS_KEY.lotCreatedAtFilter,
  },

  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.isWineSetFilter),
    filterName: ADMIN_FILTERS_NAME.isWineSetFilter,
    apiFilterName: ADMIN_FILTERS_KEY.isWineSetFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.isMerchantSetFilter),
    filterName: ADMIN_FILTERS_NAME.isMerchantSetFilter,
    apiFilterName: ADMIN_FILTERS_KEY.isMerchantSetFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.invalidRecordFilter),
    filterName: ADMIN_FILTERS_NAME.invalidRecordFilter,
    apiFilterName: ADMIN_FILTERS_KEY.invalidRecordFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.lastUpdateFilter),
    filterName: ADMIN_FILTERS_NAME.updatedAtFilter,
    apiFilterName: ADMIN_FILTERS_KEY.updatedAtFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.createdAtFilter),
    filterName: ADMIN_FILTERS_NAME.createdAtFilter,
    apiFilterName: ADMIN_FILTERS_KEY.createdAtFilter,
  },
  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(ADMIN_FILTERS_TITLE.creationUserFilter),
    filterName: ADMIN_FILTERS_NAME.updateUserUsernameFilter,
    apiFilterName: ADMIN_FILTERS_KEY.updateUserUsernameFilter,
  },
]

export const adminTradeOffersFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationTradeOffersFiltersCollection,
  pathToStore: [],
  filtersDataPath: ['admin', 'tradeOffers', 'tradeOfferLotsFilters'],
  showResultsTextKey: 'filters.button.apply',
}
